import { useSelector } from 'react-redux';
import { Table } from '@quintoandar-tokko/jopijs';
import ProductionRateTableRow from './ProductionRateTableRow';
import CollapsibleRow from '../components/CollapsibleRow';
import LoadingMoreSkeleton from '../components/LoadingMoreSkeleton';

export default function ProductionRateGroupedTableContent({ headers }) {
  const { productionRate } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );

  return (
    <Table.Rows>
      {productionRate.branches.map((branch) => {
        const items = [
          `${branch.branch.name} (${branch.agents?.length})`,
          branch.production_rate,
          branch.appraised,
          branch.entered,
          branch.fallen,
          branch.in_progress,
        ];

        return (
          <CollapsibleRow key={branch.branch_id} items={items}>
            {branch?.agents?.map((agent, index) => (
              // eslint-disable-next-line
              <ProductionRateTableRow key={index} row={agent} />
            ))}
          </CollapsibleRow>
        );
      })}

      {productionRate.loading && (
        <LoadingMoreSkeleton columns={headers.length} />
      )}
    </Table.Rows>
  );
}
